// src/components/Header.js

import React, { useState } from "react";
import { Link } from "react-router-dom";



const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="grid grid-cols-3 items-center px-6 py-4 shadow-sm relative z-50 bg-white">
      {/* Sol: Marka */}
      <div className="text-left text-xl font-brand">
        Seratics
      </div>

      {/* Orta: Logo */}
      <div className="flex justify-center">
      <Link to="/">
  <img src="/images/logo.png" alt="Logo" className="h-8 w-8 cursor-pointer" />
</Link>

        
      </div>

      {/* Sağ: Masaüstü Menü */}
      <nav className="hidden md:flex justify-end gap-6 text-sm">
        <a href="#about" className="hover:underline">Hakkımızda</a>
        <a href="#products" className="hover:underline">Ürünler</a>
        <a href="#contact" className="hover:underline">İletişim</a>
      </nav>

      {/* Mobil Buton */}
      <button
        onClick={() => setMenuOpen(!menuOpen)}
        className="md:hidden absolute right-6 top-4 text-2xl"
        aria-label="Menüyü Aç"
      >
        ☰
      </button>

      {/* Mobil Menü */}
      {menuOpen && (
        <div className="absolute top-full right-6 mt-2 bg-white shadow rounded p-4 space-y-2 text-sm md:hidden">
          <a href="#about" className="block hover:underline"></a>
          <a href="#products" className="block hover:underline"></a>
          <a href="#contact" className="block hover:underline"></a>
        </div>
      )}
    </header>
  );
};

export default Header;
